import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const SeniorCare = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my senior care business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps senior care businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for senior care businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most senior care businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my senior care business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like senior care. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Senior Care - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Senior Care CRM", url: "/industries/senior-care" }
  ];

  const industryData = {
    name: 'Senior Care & Home Health',
    title: 'Build Trust with Families & Streamline Caregiver Scheduling',
    subtitle: 'Automate family updates, manage caregiver schedules, and grow your home care agency',
    icon: '👴',
    challenges: [
      'Family inquiries come in at all hours',
      'Hard to communicate care updates to families',
      'Caregiver scheduling is complex',
      'Difficult to get client referrals',
      'Compliance documentation is time-consuming'
    ],
    solutions: [
      'Inquiry capture 24/7',
      'Automated family update system',
      'Caregiver schedule optimization',
      'Referral program automation',
      'Compliance tracking'
    ],
    features: [
      'Family portal with updates',
      'Caregiver scheduling',
      'Service visit tracking',
      'Medication reminders',
      'Emergency contact management',
      'Compliance documentation',
      'Billing automation',
      'Review requests'
    ],
    results: [
      '70% of inquiries convert',
      '95% family satisfaction',
      '40% more referrals',
      '£7.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Senior Care UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for senior care businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for senior care UK, senior care business software, senior care customer management, senior care lead generation UK"
        url="/industries/senior-care"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default SeniorCare;